import React from 'react';
import CustomBox from '../CommonComp/CustomBox/CustomBox';
import AllUserList from './AllUserList';

function UserTabBody({ activeTab }) {
  return (
    <CustomBox
      padding={0}
      sx={{
        minHeight: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {activeTab == 1 && <AllUserList />}
    </CustomBox>
  );
}

export default UserTabBody;
